import React from "react";
import Button from "../../../form/Button";
import { classNames } from "../../../../helpers/classNames";

const TextBlock = ({ title, description, action, containerClasses }) => {
  return (
    <>
      <section className="relative flex w-full pt-8 pb-0 lg:pt-16 lg:pb-0 xl:py-24 bg-white">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className={classNames("max-w-6xl mx-auto", containerClasses)}>
            <div className="space-y-10">
              {title && (
                <h2 className="text-3xl sm:text-4xl xls:text-[42px] font-bold text-center">
                  {title}
                </h2>
              )}
              {description && (
                <div
                  className="text-base xls:text-lg xls:font-medium font-Gotham text-center"
                  dangerouslySetInnerHTML={{ __html: description }}
                ></div>
              )}
              {action && (
                <div className="flex items-center justify-center">
                  <Button
                    buttonLabel={action?.label}
                    buttonClasses={classNames(
                      "!h-12 xl:!h-14 !rounded-full !px-6 xl:!px-10 border border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white min-w-60",
                      action?.classes
                    )}
                    buttonLabelClasses={classNames(
                      "!text-base xl:!text-xl",
                      action?.labelClasses
                    )}
                    buttonFunction={action?.isLink ? () => {} : action?.click}
                    buttonHasLink={action?.isLink}
                    buttonLink={action?.isLink ? action?.link : null}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TextBlock;
